import { Component, Input } from '@angular/core';
import { TextField } from '@sitecore-jss/sitecore-jss-angular';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TranslatePipe } from '@ngx-translate/core';

import { RichTextWrapperComponent } from '../rich-text-wrapper/rich-text-wrapper.component';

@Component({
  selector: 'wl-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: [
    './error-message.component.essent.scss',
    './error-message.component.ed.scss',
  ],
  standalone: true,
  imports: [
    FaIconComponent,
    AutomationIdDirective,
    RichTextWrapperComponent,
    TranslatePipe,
  ],
})
export class ErrorMessageComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageTranslationKey?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() message?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageTranslationParams?: string;
}
